import { SelectableOption } from '../context/reducers/selectorReducer'

export function normalizeMedidaOption(
  opt: unknown
): SelectableOption<string | number> {
  if (opt === null || opt === undefined || opt === '') {
    return { label: '', value: '' }
  }

  if (typeof opt === 'object') {
    const record = opt as {
      label?: string | number | null
      value?: string | number | null
    }
    if (record.value != null && record.value !== '') {
      const value = record.value
      const label =
        record.label != null && record.label !== ''
          ? String(record.label)
          : String(value)
      return { label, value }
    }
    if (record.label != null && record.label !== '') {
      const label = String(record.label)
      return { label, value: label }
    }
  }

  return { label: String(opt), value: opt as string | number }
}

export function normalizeMedidaOptions(
  options: unknown[] | undefined
): SelectableOption<string | number>[] {
  return (options ?? [])
    .map(normalizeMedidaOption)
    .filter((opt) => opt.value !== '' && opt.value != null)
}
